
import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid } from "@mui/material"
import { AutocompleteComponent } from "components/Autocomplete/AutocompleteComponent";
import { useFetchLocal } from "hooks/fetch-hooks/useFetchLocal"
import { handleUltimateFetchLessData, handleFetchLessDataOneStation } from "views/Closeouts-Settlements/actions/fetchData";
import RegularButton from "components/CustomButtons/Button";
import SearchIcon from "@mui/icons-material/Search";
import { blue } from "@mui/material/colors";


export const CustomerComponent = ({
    customers = false,
    multi = false,
    state,
    dispatchAction = () => null
}) => {
    const [
        [data, loading, success, error, message],
        fetchCustomers,
    ] = useFetchLocal(multi ? handleUltimateFetchLessData : handleFetchLessDataOneStation);

    const { stations } = useSelector(({ companies }) => companies);

    const dispatch = useDispatch();

    const submit = (e) => {
        e.preventDefault()
        fetchCustomers(state?.station, state?.searchCustomer, stations, setValues);
    }

    const setValues = (value) => {
        value?.customersOpt && dispatch(dispatchAction("customersOpt", value.customersOpt))
        value?.searchCustomer && dispatch(dispatchAction("searchCustomer", value.searchCustomer))
    }

    const stationIds = useMemo(() => (
      Array.isArray(state?.station)
        ? state.station.map((s) => s?.id).join(",")
        : state?.station?.id ?? null
    ), [state?.station]);

    useEffect(() => {
        dispatch(dispatchAction("customer", null));
        dispatch(dispatchAction("customersOpt", []));
        dispatch(dispatchAction("searchCustomer", []))
    }, [stationIds]);
    
    return (
        <Grid item xs={12} sm={3}>
            <AutocompleteComponent
                label={"Cliente"}
                size={"small"}
                options={state?.customersOpt || []}
                name={"idAccount"}
                value={state?.customer || null}
                search={state?.searchCustomer}
                customAction={v => dispatch(dispatchAction("customer", v))}
                disabled={(Array.isArray(state?.station) ? state.station.length === 0 : !state?.station) || loading}
                textFieldProps={{
                    onChange: ({ target }) => dispatch(dispatchAction("searchCustomer", target.value))
                }}
                onAction={
                    <RegularButton
                        type="button"
                        justIcon
                        round
                        color="transparent"
                        size="sm"
                        onClick={submit}
                        loading={loading}
                        disabled={Array.isArray(state?.station) ? state.station.length === 0 : !state?.station}
                    >
                        <SearchIcon sx={{ color: blue[700] }} />
                    </RegularButton>
                }
                noOptionsText="No se encuentra cliente"
            />
        </Grid>
    );
};

